import React from "react";
import { Play, Square } from "lucide-react";
import { fmtHMS, hoursBetween } from "./utils";
import GpsChip from "./GpsChip";

export default function SelfView({ viewerId, employees, entries, onClockToggle, totalHoursForEmployee }) {
    const me = employees.find((e) => e.member_user_id === viewerId);
    if (!me) {
        return (
            <div className="text-sm text-slate-400 bg-[#131A2F] border border-[#2A3655] rounded-md p-4">
                You haven't been added as an employee yet. Ask your administrator to add you.
            </div>
        );
    }
    const isOpen = !!me.open_entry;
    const mine = entries.filter((e) => e.employee_id === me.id).slice(0, 30);
    return (
        <div>
            <div className={`flex items-center justify-between gap-4 px-4 py-5 rounded-md border mb-5 ${isOpen ? "bg-emerald-500/10 border-emerald-500/50" : "bg-[#131A2F] border-[#2A3655]"}`}>
                <div>
                    <div className="text-xs uppercase tracking-wider text-slate-400 font-bold">{me.name}</div>
                    <div className="text-2xl font-bold text-white">{totalHoursForEmployee(me.id).toFixed(2)}h <span className="text-xs text-slate-400 font-normal">period total</span></div>
                </div>
                <button
                    onClick={() => onClockToggle(me)}
                    data-testid="btn-self-clock"
                    className={`inline-flex items-center gap-2 px-4 py-3 rounded-sm font-bold text-sm uppercase tracking-wider transition-colors ${isOpen ? "bg-rose-500/25 text-rose-100 border border-rose-500/60 hover:bg-rose-500/35" : "bg-emerald-500/25 text-emerald-100 border border-emerald-500/60 hover:bg-emerald-500/35"}`}
                >
                    {isOpen ? <><Square className="w-4 h-4" />Clock out</> : <><Play className="w-4 h-4" />Clock in</>}
                </button>
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 font-bold mb-2">Recent entries</div>
            <div className="space-y-1.5">
                {mine.length === 0 && <div className="text-slate-400 text-sm">No entries yet.</div>}
                {mine.map((e) => (
                    <div key={e.id} className="bg-[#131A2F] border border-[#2A3655] rounded-sm px-3 py-2 text-sm flex flex-wrap items-center gap-x-3 gap-y-0.5" data-testid={`self-entry-${e.id}`}>
                        <span className="text-slate-300">{e.date}</span>
                        <span className="font-mono text-xs text-slate-400">{fmtHMS(e.start_time)} → {e.end_time ? fmtHMS(e.end_time) : "live"}</span>
                        <span className="ml-auto font-mono text-[#00A3FF]">{(e.end_time ? hoursBetween(e.start_time, e.end_time) : 0).toFixed(2)}h</span>
                        {(e.clock_in_location || e.clock_out_location) && (
                            <div className="basis-full flex flex-wrap gap-x-3 gap-y-0.5 text-[11px] mt-1">
                                <GpsChip loc={e.clock_in_location} kind="in" testId={`self-entry-clockin-gps-${e.id}`} />
                                <GpsChip loc={e.clock_out_location} kind="out" testId={`self-entry-clockout-gps-${e.id}`} />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
